import { UIText2, IconCar16, IconTrain16, IconHighway16 } from '@cian/ui-kit';
import * as React from 'react';

import { INFO_DELIMITER, INFO_DELIMITER_MOBILE } from '../../utils';
import { Link } from '../Link';

import * as styles from './index.css';

export enum ECommuteSetType {
  Highway,
  HighwayMobile,
  Railway,
}

interface ICommuteSetProps {
  title: string;
  distanceText: string;
  type?: ECommuteSetType;
  link?: string;
  trackEvent?(): void;
}

export const CommuteSet = ({ title, distanceText, link, type, trackEvent }: ICommuteSetProps) => {
  const icon = React.useMemo(() => {
    switch (type) {
      case ECommuteSetType.Highway:
        return <IconCar16 />;
      case ECommuteSetType.HighwayMobile:
        return <IconHighway16 />;
      case ECommuteSetType.Railway:
        return <IconTrain16 />;
      default:
        return null;
    }
  }, [type]);

  const [dataNameType, dataNameDistance] =
    type === ECommuteSetType.Railway ? ['CardRailway', 'CardRailwayDistance'] : ['CardHighway', 'CardHighwayDistance'];

  const delimiter = type === ECommuteSetType.HighwayMobile ? INFO_DELIMITER_MOBILE : INFO_DELIMITER;

  return (
    <div className={styles['commute']}>
      <span className={styles['commute-icon']}>{icon}</span>
      {link ? (
        <Link href={link} target="_blank" onClick={trackEvent} data-name={dataNameType}>
          <UIText2 display="inline">
            <span className={styles['title-link']}>{title}</span>
          </UIText2>
        </Link>
      ) : (
        <UIText2 display="inline" data-name={dataNameType}>
          {title}
        </UIText2>
      )}
      {!!distanceText && (
        <>
          {delimiter}
          <UIText2 display="inline" color="gray60_100" data-name={dataNameDistance}>
            {distanceText}
          </UIText2>
        </>
      )}
    </div>
  );
};
